import React, { useEffect, useState, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { ThankYouPage } from './pages/ThankYouPage';
const GTM_ID = 'GTM-5L9W7QQQ';
export function App() {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);
  useEffect(() => {
    // Google Tag Manager — inject into <head>
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`;
    document.head.insertBefore(script, document.head.firstChild);
  }, []);
  const renderPage = () => {
    if (path === '/thankyou') return <ThankYouPage data-id="element-0" />;
    return <LandingPage data-id="element-1" />;
  };
  return <>
      {/* Google Tag Manager (noscript) */}
      <noscript data-id="element-2">
        <iframe src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`} height="0" width="0" style={{
        display: 'none',
        visibility: 'hidden'
      }} data-id="element-3" />
      </noscript>
      {renderPage()}
    </>;
}